import { makeAutoObservable } from 'mobx';
import type { SelectRows } from 'ksnm-common-ui/lib/Table2/contexts/Table/TableContext.interface';
import type { ExternalFetch } from 'ksnm-common-ui/lib/Table2/Table.interface';
import type { TableRequest } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { cmApi, customRequest } from '@src/api';
import type { CmApi, OperationEnum, RequestParams, TableComponentRequestDto } from '@src/api';

import { preloaderStore } from '../preloaderStore';

export const TABLE_CONFIG = '___ksnm_tables_v2';
export const GROUP_COLUMN_NAME = '___group_column_849gh8939gg24';

class KsnmTableStore {
  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  hasSelectedRows = (selectRows: SelectRows) => {
    if (!selectRows) return false;
    const keys = Object.keys(selectRows);
    if (keys) {
      return (
        keys.some((el) => Array.isArray(selectRows?.[el]) && selectRows?.[el]?.length) || !!selectRows?.modeSelectAll
      );
    }
    return false;
  };

  getExcelStreamV2: ExternalFetch = async (tableInfo) => {
    preloaderStore.preloader(true);

    try {
      return await customRequest({
        path: `/tableComponentV2/excel`,
        method: 'POST',
        body: tableInfo,
      });
    } catch (error) {
      console.error(error);
    } finally {
      preloaderStore.preloader(false);
    }
  };

  externalFetch = async (tableInfo: TableRequest, params?: RequestParams) => {
    try {
      return await cmApi.tableComponentV2.getTableJson(tableInfo as TableComponentRequestDto, params);
    } catch (error) {
      console.error(error);
    }
  };

  operateRows = async (tableInfo: TableComponentRequestDto, operationMode: OperationEnum) => {
    preloaderStore.preloader(true);

    const data: TableComponentRequestDto = {
      ...tableInfo,
      operation: { ...tableInfo.operation, operationMode: operationMode },
    };

    try {
      const { error } = await this.api.tableComponentV2.operateSelected(data);
      preloaderStore.preloader(false);
      return !error;
    } catch (error) {
      console.error(error);
      preloaderStore.preloader(false);
    }
  };

  getCountSelected = async (tableInfo: TableComponentRequestDto) => {
    preloaderStore.preloader();
    const { data } = await this.api.tableComponentV2.countSelected(tableInfo);
    preloaderStore.preloader(false);
    return data ?? 0;
  };

  clearSelectedFromLocalStorage = (tableName: string) => {
    const lsData = localStorage.getItem(TABLE_CONFIG);
    const config = lsData ? JSON.parse(lsData) : {};

    if (config?.[tableName]) {
      localStorage.setItem(
        TABLE_CONFIG,
        JSON.stringify({
          ...config,
          [tableName]: {
            ...config[tableName],
            selectRows: { deSelectedGroups: [], deSelectedRowKeys: [], selectedGroups: [], selectedRowKeys: [] },
          },
        }),
      );
    }
  };
}

export const ksnmTableStore = new KsnmTableStore({
  api: cmApi,
});
